var _span, _span2, _span3, _span4;
/* global caiprivacy */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reaxl';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NonstaticFooterLegal = /*#__PURE__*/React.memo(_ref => {
  let {
    className,
    renderThirdParty = true,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(className, 'text-legal text-center text-size-200 col-sm-12'),
    ...rest,
    children: [_span || (_span = /*#__PURE__*/_jsx("span", {
      children: "By using this service, you accept the terms of our\xA0"
    })), _span2 || (_span2 = /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx("a", {
        className: "display-inline-block",
        href: "/legal/visitor-agreement",
        children: "Visitor Agreement"
      }), /*#__PURE__*/_jsx("span", {
        children: "."
      })]
    })), /*#__PURE__*/_jsxs("span", {
      className: "margin-horizontal-2",
      children: [/*#__PURE__*/_jsx(Button, {
        className: "display-inline-block",
        onClick: e => {
          e.preventDefault();
          if (typeof caiprivacy !== 'undefined') {
            caiprivacy?.privacyStatement();
          }
        },
        bsStyle: "text-decorated",
        children: "Privacy Statement"
      }), _span3 || (_span3 = /*#__PURE__*/_jsx("span", {
        children: "."
      }, "dot"))]
    }), _span4 || (_span4 = /*#__PURE__*/_jsxs("span", {
      className: "margin-left-0",
      children: [/*#__PURE__*/_jsx("a", {
        className: "display-inline-block",
        href: "//www.autotrader.com/legal/accessibility-statement",
        children: "Accessibility Statement"
      }), /*#__PURE__*/_jsx("span", {
        children: "."
      })]
    })), /*#__PURE__*/_jsxs("div", {
      children: ["\xA9", new Date().getFullYear() + ' ', "Autotrader, Inc. All Rights Reserved. \"Autotrader\" is a registered trademark of TPI Holdings, Inc. used under exclusive license."]
    })]
  });
});
NonstaticFooterLegal.propTypes = {
  /**
   * Base classname
   */
  className: PropTypes.string,
  /**
   * Boolean to render third party libraries
   */
  renderThirdParty: PropTypes.bool
};
export default NonstaticFooterLegal;